"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.f7869 = void 0;
exports.f7869 = {
    "ẽbẽra": [
        1532
    ],
    "ẽ́bẽra katío": [
        1668
    ],
    "ẽ́bẽra": [
        1668
    ],
    "ẽbẽrã bed’ea–katío": [
        1668
    ],
    "ẽbẽrã": [
        1668
    ]
};
